const accordion = (() => {
  const defaultAccordion = () => {

    const accordionFirstElem = document.getElementsByClassName('js-trigger-elem');

    for (let i = 0; i < accordionFirstElem.length; i += 1) {
      accordionFirstElem[i].addEventListener('click', function (event) {
        event.currentTarget.classList.toggle('js-active');
      });
    }

    const accordionItem = document.getElementsByClassName('js-trigger-accordion');

    for (let i = 0; i < accordionItem.length; i += 1) {
      accordionItem[i].addEventListener('click', function (event) {
        event.currentTarget.classList.toggle('js-active');
        const accordionContent = this.nextElementSibling;
        accordionContent.classList.toggle('js-active');
      });
    }

    const accordionItemHs = document.getElementsByClassName('js-trigger-accordion-hs');

    for (let i = 0; i < accordionItemHs.length; i += 1) {
      accordionItemHs[i].addEventListener('click', function (event) {
        event.currentTarget.classList.toggle('js-active');
        const accordionContentHs = this.nextElementSibling;
        accordionContentHs.classList.toggle('hidden');
      });
    }
  };


  const v2Accordion = () => {
    document.addEventListener('DOMContentLoaded', function () {
      const accordionItems = document.getElementsByClassName('js-trigger-accordion-v2');
      const accordionImage = document.querySelector('.right-accordion-img img');
    
      if (accordionItems.length > 0) {
        // İlk akordeon için başlangıç resmi ayarla
        const firstAccordion = accordionItems[0];
        const initialImgSrc = firstAccordion.getAttribute('data-img');
        if (initialImgSrc && accordionImage) {
          accordionImage.setAttribute('src', initialImgSrc);
          accordionImage.setAttribute('alt', firstAccordion.innerText.trim());
          firstAccordion.classList.add('js-active');
          const firstContent = firstAccordion.nextElementSibling;
          if (firstContent) {
            firstContent.classList.add('js-active');
          }
        }
    
        // Akordeon tıklamalarını dinle
        for (let i = 0; i < accordionItems.length; i += 1) {
          accordionItems[i].addEventListener('click', function (event) {
            // Tüm akordeonları kapat
            for (let j = 0; j < accordionItems.length; j += 1) {
              accordionItems[j].classList.remove('js-active');
              const content = accordionItems[j].nextElementSibling;
              if (content) {
                content.classList.remove('js-active');
              }
            }
    
            // Tıklanan akordeonu aç
            event.currentTarget.classList.toggle('js-active');
            const accordionContent = event.currentTarget.nextElementSibling;
            if (accordionContent) {
              accordionContent.classList.toggle('js-active');
            }
    
            // `data-img` değerini al ve `src` olarak img'ye ata
            const imgSrc = event.currentTarget.getAttribute('data-img');
            if (imgSrc && accordionImage) {
              accordionImage.setAttribute('src', imgSrc);
              accordionImage.setAttribute('alt', event.currentTarget.innerText.trim()); // Alt için başlık
            }
          });
        }
      }
    });
    
  };


  const dtLeftAcc = () => {
    document.addEventListener('DOMContentLoaded', function () {
      if (document.querySelector('.dt-left-menu .menu-title') && document.querySelector('.dt-left-menu .menu-nav')) {
        const menuTitle = document.querySelector('.dt-left-menu .menu-title');
        const menuNav = document.querySelector('.dt-left-menu .menu-nav');
        
        menuTitle.addEventListener('click', function () {
          if (window.innerWidth <= 992) {
            menuTitle.classList.toggle('active');
            menuNav.classList.toggle('!block');
          }
        });
      }
    });
  };

  const mobileDetailFilterMenu = () => {
    document.addEventListener('DOMContentLoaded', function () {
      const mobileFilterTrigger = document.querySelector('.mobile-detail-filter-menu');
      const detailFilterMenu = document.querySelector('.detail-filter-menu');
      const filterClose = document.querySelector('.filter-close');
      if (!mobileFilterTrigger || !detailFilterMenu || !filterClose) {
        return;
      }

      mobileFilterTrigger.addEventListener('click', function () {
        detailFilterMenu.classList.toggle('js-mobile-open');
        document.body.classList.toggle('overflow-hidden');
      });
      filterClose.addEventListener('click', function () {
        detailFilterMenu.classList.remove('js-mobile-open');
        document.body.classList.remove('overflow-hidden');
      });

      document.addEventListener('click', function (event) {
        if (event.target.closest('.apply-filter')) {
          detailFilterMenu.classList.remove('js-mobile-open');
          document.body.classList.remove('overflow-hidden');
        }
      });
    });
  };

  const rentalImageHoverSlider = () => {
    document.addEventListener('DOMContentLoaded', function () {
      const imageItems = document.querySelectorAll('.filter-result-item-image .image-item');

      imageItems.forEach((imageItem) => {
        const slides = imageItem.querySelectorAll('.image-slider-item');
        const navItems = imageItem.parentElement?.querySelectorAll('.image-slider-nav .image-slider-nav-item') || [];

        if (!slides.length) {
          return;
        }

        let activeIndex = 0;

        const setActiveSlide = (index) => {
          activeIndex = Math.max(0, Math.min(index, slides.length - 1));

          slides.forEach((slide, slideIndex) => {
            slide.classList.toggle('hidden', slideIndex !== activeIndex);
          });

          navItems.forEach((navItem, navIndex) => {
            navItem.classList.toggle('active', navIndex === activeIndex);
          });
        };

        // Baslangicta sadece ilk gorsel gorunsun.
        setActiveSlide(0);

        let hoverZones = imageItem.querySelector('.image-hover-zones');
        if (!hoverZones) {
          hoverZones = document.createElement('div');
          hoverZones.className = 'image-hover-zones absolute inset-0 z-10 flex';

          slides.forEach((_, index) => {
            const zone = document.createElement('span');
            zone.className = 'hover-zone block h-full flex-1';
            zone.setAttribute('aria-hidden', 'true');
            zone.addEventListener('mouseenter', () => {
              setActiveSlide(index);
            });
            hoverZones.appendChild(zone);
          });

          imageItem.appendChild(hoverZones);
        }

        // Mobilde sola/saga kaydirarak gorsel degistirme
        let touchStartX = 0;
        let touchEndX = 0;
        const swipeThreshold = 40;

        imageItem.addEventListener('touchstart', (event) => {
          touchStartX = event.changedTouches[0].clientX;
        }, { passive: true });

        imageItem.addEventListener('touchmove', (event) => {
          touchEndX = event.changedTouches[0].clientX;
        }, { passive: true });

        imageItem.addEventListener('touchend', () => {
          const diffX = touchEndX - touchStartX;

          if (Math.abs(diffX) < swipeThreshold) {
            touchStartX = 0;
            touchEndX = 0;
            return;
          }

          if (diffX < 0) {
            setActiveSlide(activeIndex + 1);
          } else {
            setActiveSlide(activeIndex - 1);
          }

          touchStartX = 0;
          touchEndX = 0;
        }, { passive: true });
      });
    });
  };


  const init = () => {
    defaultAccordion();
    v2Accordion();
    dtLeftAcc();
    mobileDetailFilterMenu();
    rentalImageHoverSlider();
  };

  return {
    init,
  };
})();

export default accordion;
